import { all_routes } from "../../../feature-module/router/all_routes";
import { usePermissions } from "../../../hooks/usePermissions";
const route = all_routes;
export const SidebarData = [
  {
    label: "DASHBOARD",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Dashboard",
    submenuItems: [
      {
        label: "Analytics",
        icon: "ti ti-chart-bar",
        showSubRoute: false,
        link: route.dashboardAnalytics
      },
      {
        label: "Configurações",
        icon: "ti ti-settings-cog",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          { label: "Objetivos", link: route.dashboardObjectives },
        ],
      }
    ],
  },
  {
    label: "OPORTUNIDADES",
    link: route.dealsKanban,
    submenuItems: [
      {
        label: "Cadastro",
        icon: "ti ti-file-plus",
        showSubRoute: false,
        link: route.dealsKanban
      },
      {
        label: "Configurações",
        icon: "ti ti-settings-cog",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Funis", link: route.pipeline },
          { label: "Clientes", link: route.contactList },
          { label: "Fornecedores", link: route.fornecedores },
          { label: "Origens", link: route.origens },
          { label: "Status de Oportunidades", link: route.opportunityStatus },
          { label: "Campos Personalizados", link: route.camposPersonalizados },
          { label: "Orçamentos", link: route.configuracoesOrcamento }
        ],
      },
    ],
  },
  {
    label: "CONTRATOS",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Contracts",
    submenuItems: [
      {
        label: "Listagem",
        link: route.ContractsList,
        icon: "ti-menu-alt",
        showSubRoute: false,

      }
    ]
  },
  {
    label: "PRODUTOS",
    link: route.produtos,
    submenuItems: [
      {
        label: "Cadastro",
        icon: "ti ti-file-plus",
        showSubRoute: false,
        link: route.produtos
      },
      {
        label: "Configurações",
        icon: "ti ti-settings-cog",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Unidades de Medida", link: route.unidadesMedida }
        ],
      },
    ],
  },
  
  {
    label: "FINANCEIRO",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Finance",
    submenuItems: [
      {
        label: "Lançamentos",
        link: route.payments,
        icon: "ti ti-file-invoice",
        showSubRoute: false,
        
      },
      {
        label: "Contas a Pagar",
        link: route.contasAPagar,
        icon: "ti ti-cash",
        showSubRoute: false,
        
      },
      {
        label: "Contas a Receber",
        link: route.contasAReceber,
        icon: "ti-receipt",
        showSubRoute: false,
        
      },
      {
        label: "Configurações",
        icon: "ti ti-settings-cog",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Categorias", link: route.categoriasFinanceiras },
          { label: "Contas Bancárias", link: route.contasBancarias },
          { label: "Formas de Pagamento", link: route.formasPagamento }
        ],
      }
    ],
  },
  
  {
    label: "CONFIGURAÇÕES",
    link: route.resetPassword,
    submenuItems: [
      {
        label: "Meus Dados",
        link: route.profile,
        icon: "ti ti-user",
        showSubRoute: false,
        
      },
      {
        label: "Alterar senha",
        icon: "ti ti-lock-square-rounded",
        showSubRoute: false,
        link: route.resetPassword
      }
    ],
  },
  {
    label: "ADMINISTRATIVO",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Admin",
    submenuItems: [
      {
        label: "Usuários",
        link: route.userManager,
        icon: "ti ti-users",
        showSubRoute: false,
        
      },
      {
        label: "Perfis",
        link: route.perfisManager,
        icon: "ti ti-users",
        showSubRoute: false,
        
      }
    ],
  },
  /*
  {
    label: "CONTRATOS",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Contracts",
    submenuItems: [
      {
        label: "Listagem",
        link: route.ContractsList,
        icon: "ti-menu-alt",
        showSubRoute: false,
        
      },
      {
        label: "Relatórios",
        icon: "ti ti-report",
        showSubRoute: false,
        
      }
    ],
  },
  {
    label: "ORÇAMENTOS",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Budget",
    submenuItems: [
      {
        label: "Listagem",
        link: route.ProposalsList,
        icon: "ti-menu-alt",
        showSubRoute: false,
        
      },
    ],
  },
  */
  {
    label: "LOGOUT",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Admin",
    submenuItems: [
      {
        label: "Sair",
        icon: "ti ti-lock",
        showSubRoute: false,
        link: route.login
      }
    ]
  }
];

// Função para usar no componente do sidebar
export const useFilteredSidebarData = () => {
  const { canViewModule, hasPermission } = usePermissions();
  
  const filterSubmenuItems = (items: any[], moduleMap: { [key: string]: string }): any[] => {
    return items.filter(item => {
      // Se tem submenu, filtrar recursivamente
      if (item.submenuItems) {
        const filteredSubItems: any[] = filterSubmenuItems(item.submenuItems, moduleMap);
        return filteredSubItems.length > 0;
      }
      
      // Verificar permissão específica baseada no link/funcionalidade
      if (item.link) {
        // Mapeamento específico para submenus
        if (item.link.includes('pipeline')) return canViewModule('CONFIG_FUNIS');
        if (item.link.includes('contactList')) return canViewModule('CONFIG_CLIENTES');
        if (item.link.includes('fornecedores')) return canViewModule('CONFIG_FORNECEDORES');
        if (item.link.includes('origens')) return canViewModule('CONFIG_ORIGENS');
        if (item.link.includes('status-oportunidade')) return canViewModule('OPORTUNIDADES');
        if (item.link.includes('camposPersonalizados')) return canViewModule('CONFIG_CAMPOS_PERSONALIZADOS');
        if (item.link.includes('configuracoesOrcamento')) return canViewModule('CONFIG_ORCAMENTOS');
        if (item.link.includes('produtos')) return canViewModule('PRODUTOS');
        if (item.link.includes('payments') || item.link.includes('contasAPagar') || item.link.includes('contasAReceber') || item.link.includes('categoriasFinanceiras') || item.link.includes('contasBancarias')) {
          return canViewModule('FINANCEIRO');
        }
        if (item.link.includes('userManager') || item.link.includes('perfisManager')) {
          return canViewModule('CONFIG_USUARIOS');
        }
      }
      
      return true; // Mostrar por padrão para itens não mapeados
    });
  };
  
  return SidebarData.filter(section => {
    const moduleMap: { [key: string]: string } = {
      'OPORTUNIDADES': 'OPORTUNIDADES',
      'CONTRATOS': 'CONTRATOS', 
      'PRODUTOS': 'PRODUTOS',
      'FINANCEIRO': 'FINANCEIRO',
      'ADMINISTRATIVO': 'ADMIN_USUARIOS'
    };

    const moduleCode = moduleMap[section.label];
    
    // Se não for um módulo mapeado (ex: LOGOUT, CONFIGURAÇÕES), sempre mostrar
    if (!moduleCode) {
      // Mas filtrar os submenus se existirem
      if (section.submenuItems) {
        section.submenuItems = filterSubmenuItems(section.submenuItems, moduleMap);
      }
      return true;
    }
    
    // Para módulos mapeados, verificar permissão
    const hasModuleAccess = canViewModule(moduleCode);
    
    if (hasModuleAccess && section.submenuItems) {
      // Se tem acesso ao módulo, filtrar os submenus
      section.submenuItems = filterSubmenuItems(section.submenuItems, moduleMap);
      
      // Só mostrar a seção se tem pelo menos um submenu visível
      return section.submenuItems.length > 0;
    }
    
    return hasModuleAccess;
  }).map(section => ({ ...section })); // Criar cópia para não modificar o original
};

